var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slider__mockup-cards" },
    _vm._l(_vm.symbolsCards, function(card, cardIndex) {
      return _c(
        "div",
        {
          key: "slider-mockup-card--" + cardIndex,
          ref: "card",
          refInFor: true,
          staticClass: "slider__mockup-card",
          attrs: { "data-index": cardIndex, "data-card": card }
        },
        [_c("v-icon", { attrs: { name: "symbols/cards/" + card } })],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }